export default {
  propertyDetails: {},
  activities: null,
  activityDetails: null,
  priceDetails: null,
  startActivityMap: null,
  paymentTypes: null,
  confirmationData: null,
  guestData: null
}